import {
  calculateBusinessAssetsSubformResults,
  calculateCarUsageSubform1PctMethodResults,
  calculateCarUsageSubformDriversLogResults,
  calculateOfficeUsageSubformFlatRate5EurResults,
  calculateOfficeUsageSubformFullCostResults,
  calculateOfficeUsageSubformUpTo1250EurResults,
  calculateTravelExpensesSubformResults,
  EuerDeclarationSubformCalculator,
} from ".";
import {
  EuerDeclarationSubformType,
  EuerDeclarationSubformCalculationMethod,
} from "../enums";

const CALCULATE_FUNCTIONS: {
  [type: string]: {
    [calculationMethod: string]: EuerDeclarationSubformCalculator;
  };
} = {
  [EuerDeclarationSubformType.BUSINESS_ASSETS]: {
    [EuerDeclarationSubformCalculationMethod.BUSINESS_ASSETS_DEFAULT]:
      calculateBusinessAssetsSubformResults as EuerDeclarationSubformCalculator,
  },
  [EuerDeclarationSubformType.CAR_USAGE]: {
    [EuerDeclarationSubformCalculationMethod.CAR_USAGE_1_PCT_METHOD]:
      calculateCarUsageSubform1PctMethodResults as EuerDeclarationSubformCalculator,
    [EuerDeclarationSubformCalculationMethod.CAR_USAGE_DRIVERS_LOG]:
      calculateCarUsageSubformDriversLogResults as EuerDeclarationSubformCalculator,
  },
  [EuerDeclarationSubformType.OFFICE_USAGE]: {
    [EuerDeclarationSubformCalculationMethod.OFFICE_USAGE_FLAT_RATE_5_EUR]:
      calculateOfficeUsageSubformFlatRate5EurResults as EuerDeclarationSubformCalculator,
    [EuerDeclarationSubformCalculationMethod.OFFICE_USAGE_FULL_COST]:
      calculateOfficeUsageSubformFullCostResults as EuerDeclarationSubformCalculator,
    [EuerDeclarationSubformCalculationMethod.OFFICE_USAGE_UP_TO_1250_EUR]:
      calculateOfficeUsageSubformUpTo1250EurResults as EuerDeclarationSubformCalculator,
  },
  [EuerDeclarationSubformType.TRAVEL_EXPENSES]: {
    [EuerDeclarationSubformCalculationMethod.TRAVEL_EXPENSES_DEFAULT]:
      calculateTravelExpensesSubformResults as EuerDeclarationSubformCalculator,
  },
};

export const getCalculator = (
  type: EuerDeclarationSubformType,
  calculationMethod: EuerDeclarationSubformCalculationMethod
): EuerDeclarationSubformCalculator => {
  const calculationMethodFunctions = CALCULATE_FUNCTIONS[type];
  return calculationMethodFunctions[calculationMethod];
};
